import { useEffect, useState } from 'react';

export const useIsPreviewMode = (): boolean => {
    const [isPreviewMode, setIsPreviewMode] = useState(
        typeof window !== 'undefined' && window.IS_PREVIEW_MODE === true,
    );

    useEffect(() => {
        const handlePreviewModeActivated = (event: CustomEvent<boolean>): void => {
            setIsPreviewMode(event.detail);
        };
        window.addEventListener(
            'preview-mode-activated',
            handlePreviewModeActivated as EventListener,
        );
        return () => {
            window.removeEventListener(
                'preview-mode-activated',
                handlePreviewModeActivated as EventListener,
            );
        };
    }, []); // Run once on component mount
    return isPreviewMode;
};
